import type { Track } from "@/types/types";

export function trackKey(t: Track): string { return t.id; }
export function totalDurationMs(tracks: Track[]): number {
  return tracks.reduce((a, t) => a + (t.duration_ms || 0), 0);
}
export function primaryArtistName(t: Track): string {
  return t.artist?.name ?? t.album?.artist?.name ?? "Unknown";
}
